export default __webpack_public_path__ + "static/media/baton_silver.3b9e2d8c.jpg";